import React, { useRef, useState, useImperativeHandle } from 'react';
import { get } from 'lodash';
import Modal from "../../Display/Modal/Modal";
import Button from "../../Display/Button/Button";
import AEM_CONSTANTS from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  ACTION_TYPES,
  TITLE_TEXT,
  PRE_LIST_TEXT,
  POST_LIST_TEXT,
  CONTINUE_BUTTON_TEXT,
  STAY_BUTTON_TEXT
} = AEM_CONSTANTS;
const ActionEligibilityModal = /*#__PURE__*/React.forwardRef((props, ref) => {
  const modalRef = useRef();
  const [invalidSelectionListItems, setInvalidSelectionListItems] = useState();
  const [actionButtons, setActionButtons] = useState();
  const [areAllSelectionsInvalid, setAreAllSelectionsInvalid] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const validateActionAndSelectionValues = (action, allInvalid) => {
    if (!Object.values(ACTION_TYPES).some(v => v === action)) throw new Error(`Invalid action '${action}' provided to ActionEligibilityModal`);
    const invalidStatus = allInvalid ? 'ALL_INVALID' : 'SOME_INVALID';
    Object.keys(AEM_CONSTANTS).forEach(textType => {
      if (textType !== 'ACTION_TYPES' && !AEM_CONSTANTS[textType][action][invalidStatus]
      // Special case - Referrals don't allow continuing when all selections are invalid
      && !(action === ACTION_TYPES.REFERRAL && allInvalid && textType === 'CONTINUE_BUTTON_TEXT')) {
        throw new Error(`No ${textType} text found for action '${action}' when ${allInvalid ? 'all' : 'some'} selections are invalid`);
      }
    });
  };
  const generateInvalidSelectionListItems = invalidSelections => {
    setInvalidSelectionListItems(invalidSelections.map((invalidSelection, idx) =>
    /*#__PURE__*/
    // The invalidSelections array shouldn't have the opportuntity to be reordered in any way without going through list generation again,
    // meaning it should be safe to use index as a key here
    // eslint-disable-next-line react/no-array-index-key
    _jsx("li", {
      className: "font-regular-font",
      children: invalidSelection
    }, idx)));
  };
  const generateActionButtons = (allInvalid, action, continueCallback, noContinue) => {
    // Option for just displaying "Go Back" button w/ no Continue option
    const invalidStatus = allInvalid ? 'ALL_INVALID' : 'SOME_INVALID';
    if (noContinue) {
      setActionButtons(/*#__PURE__*/_jsx(Button, {
        className: "capitalize font-heavy-font xs:mx-8 xs:mb-2",
        label: STAY_BUTTON_TEXT[action][invalidStatus],
        onClick: () => modalRef.current.closeModal()
      }));
    } else {
      setActionButtons(/*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          label: STAY_BUTTON_TEXT[action][invalidStatus],
          className: "mr-6 capitalize font-heavy-font xs:mx-8 xs:mb-2",
          onClick: () => modalRef.current.closeModal()
        }), /*#__PURE__*/_jsx(Button, {
          label: CONTINUE_BUTTON_TEXT[action][invalidStatus],
          primary: true,
          className: "capitalize text-white font-heavy-font xs:mx-8 xs:mb-2",
          onClick: () => {
            modalRef.current.closeModal();
            continueCallback();
          }
        })]
      }));
    }
  };
  const openModal = _ref => {
    let {
      invalidSelections,
      allInvalid,
      action,
      continueCallback,
      noContinue
    } = _ref;
    validateActionAndSelectionValues(action, allInvalid);
    generateInvalidSelectionListItems(invalidSelections);
    generateActionButtons(allInvalid, action, continueCallback, noContinue);
    setAreAllSelectionsInvalid(allInvalid);
    setCurrentAction(action);
    modalRef.current.openModal();
  };
  useImperativeHandle(ref, () => ({
    openModal
  }));
  const allSelectionsInvalidState = areAllSelectionsInvalid ? 'ALL_INVALID' : 'SOME_INVALID';
  return /*#__PURE__*/_jsx(Modal, {
    id: "action-eligibility-modal",
    ref: modalRef,
    modal: true,
    showBorderRadius: true,
    title: get(TITLE_TEXT, `${currentAction}.${allSelectionsInvalidState}`, ''),
    actions: actionButtons,
    titleStyles: "tracking-normal font-heavy-font text-brand-blue",
    footerStyles: "xs:flex xs:justify-center xs:flex-wrap",
    modalContentStyles: "text-base bg-light-fill-grey",
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: get(PRE_LIST_TEXT, `${currentAction}.${allSelectionsInvalidState}`, '')
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("ul", {
        className: "px-5 text-sm list-disc text-red",
        children: invalidSelectionListItems
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: get(POST_LIST_TEXT, `${currentAction}.${allSelectionsInvalidState}`, '')
      })]
    })
  });
});
ActionEligibilityModal.displayName = 'ActionEligibilityModal';
export default ActionEligibilityModal;
//# sourceMappingURL=ActionEligibilityModal.js.map